export default __webpack_public_path__ + "static/media/O-051.d70c1158.png";